// @flow
import * as React from 'react';
type Props = {
  onClick: () => any,
  label?: string,
};
const defaultLabel = 'Meta Info';
const toggleButtonClassName =
  'outline-transparent input-reset button-reset lh-solid pointer flex flex-row bg-transparent b--none blue db w-100 tl ph4 pv3 ContentSection__meta-toggle';

const MetaInfoToggle = ({ onClick, label = defaultLabel }: Props) => (
  <div className="bt bw1 b--light-gray pv1">
    <button className={toggleButtonClassName} type="button" onClick={onClick}>
      <span className="db" data-translate={true}>
        {label}
      </span>
      <i
        className="fa fa-chevron-down"
        aria-hidden="true"
        style={{ marginLeft: 'auto' }}
      />
    </button>
  </div>
);

export default MetaInfoToggle;



// WEBPACK FOOTER //
// ./src/components/ContentSection/MetaInfoToggle.js